import React from 'react'

import { EuiText } from '@elastic/eui'

export interface LegendProps {
  legendItems: Record<string, string>
  hoveredType: string | null
  onHoverChange: (type: string | null) => void
  isHoverable: boolean
}

const Legend: React.FC<LegendProps> = ({ legendItems, hoveredType, onHoverChange, isHoverable }) => {
  return (
    <div
      style={{
        position: 'absolute',
        top: '-3rem',
        left: '-.85rem',
        zIndex: 10,
        backgroundColor: 'inherit',
        padding: '8px 12px',
        borderRadius: '4px',
        display: 'flex',
        gap: '20px',
        flexWrap: 'wrap'
      }}>
      {Object.entries(legendItems).map(([name, color]) => (
        <div
          key={name}
          onMouseEnter={() => isHoverable && onHoverChange(name)}
          onMouseLeave={() => isHoverable && onHoverChange(null)}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            cursor: isHoverable ? 'pointer' : 'default',
            opacity: hoveredType === null || hoveredType === name ? 1 : 0.3,
            transition: 'opacity 0.2s ease'
          }}>
          <div
            style={{
              width: '14px',
              height: '14px',
              background: color,
              borderRadius: '3px'
            }}
          />
          <EuiText size='s' style={{ fontWeight: 'bold' }}>
            {name}
          </EuiText>
        </div>
      ))}
    </div>
  )
}

export default Legend
